import { Action } from '@ngrx/store';
import { ITotrace } from '../../models/totrace.interface';

export enum ETotRaceActions {
  GetTotRace = '[TotRace] Get TotRace',
  GetTotRaceSuccess = '[TotRace] Get TotRace Success',
  GetTotReset = '[TotRace] Get TotRace Reset',
  StopGetTotRace = '[StopGetTotRace] Stop Get Tot Race',
}

export class GetTotRace implements Action {
  public readonly type = ETotRaceActions.GetTotRace;
  constructor(public payload: string) {}
}

export class GetTotReset implements Action {
  public readonly type = ETotRaceActions.GetTotReset;
  constructor() {}
}

export class StopGetTotRace implements Action {
  public readonly type = ETotRaceActions.StopGetTotRace;
  constructor() {}
}

export class GetTotRaceSuccess implements Action {
  public readonly type = ETotRaceActions.GetTotRaceSuccess;
  constructor(public payload: ITotrace) {}
}

export type TotRaceActions = GetTotRace | GetTotRaceSuccess | GetTotReset | StopGetTotRace;
